import { BeneficiaryActionType, BeneficiaryAction } from '../actions/BeneficiaryActions';
import { PolicyBeneficiary } from '../types/api/beneficiaries/PolicyBeneficiary';

export interface BeneficiaryState {
    personBeneficiaries: {
        data: readonly PolicyBeneficiary[],
        error: unknown,
        loading: boolean
    }
}

const INITIAL_STATE: BeneficiaryState = {
    personBeneficiaries: {
        data: [],
        error: null,
        loading: false
    }
};

export default function(state = INITIAL_STATE, action: BeneficiaryAction): BeneficiaryState {
    switch(action.type) {
        case BeneficiaryActionType.FETCH_BENEFICIARIES:
            return {
                ...state,
                personBeneficiaries: {
                    data: [],
                    error: null,
                    loading: true
                }
            };
        case BeneficiaryActionType.FETCH_BENEFICIARIES_SUCCESS:
            return {
                ...state,
                personBeneficiaries: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case BeneficiaryActionType.FETCH_BENEFICIARIES_FAILURE:
            return {
                ...state,
                personBeneficiaries: {
                    data: [],
                    error: action.payload,
                    loading: false
                }
            };
        case BeneficiaryActionType.FETCH_UPDATE_BENEFICIARIES:
            return {
                ...state,
                personBeneficiaries: {
                    data: [],
                    error: null,
                    loading: true
                }
            };
        case BeneficiaryActionType.FETCH_UPDATE_BENEFICIARIES_SUCCESS:
            return {
                ...state,
                personBeneficiaries: {
                    data: state.personBeneficiaries.data,
                    error: null,
                    loading: false
                }
            };
        case BeneficiaryActionType.FETCH_UPDATE_BENEFICIARIES_FAILURE:
            return {
                ...state,
                personBeneficiaries: {
                    data: state.personBeneficiaries.data,
                    error: action.payload,
                    loading: false
                }
            };
        default:
            return state;
    }
}